import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _objectSpread from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { handlesGroup as t } from "../../core/handleUtils.js";
import { clone as n } from "../../core/lang.js";
import { clamp as e } from "../../core/mathUtils.js";
import { isSome as r, isNone as a, unwrap as o } from "../../core/maybe.js";
import { createScreenPoint as c } from "../../core/screenUtils.js";
import { f as s } from "../../chunks/vec3f64.js";
import { project as l } from "../../geometry/projection.js";
import { move as i } from "../draw/support/drawUtils.js";

function u(t, n) {
  var e = null,
      o = null;
  return function (c) {
    if ("cancel" === c.action) return void (r(o) && (o.execute({
      action: "cancel"
    }), e = null, o = null));
    var s = {
      action: c.action,
      screenStart: c.start,
      screenEnd: c.screenPoint
    };
    "start" === c.action && a(e) && (e = new b(), o = new b(), n(t, e, o, c.pointerType, s)), r(e) && e.execute(s), "end" === c.action && r(e) && (e = null, o = null);
  };
}

function m(t, n) {
  return t.events.on("drag", u(t, n));
}

function f(n, e) {
  var r = [];

  var _iterator = _createForOfIteratorHelper(n),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _t = _step.value;
      r.push(m(_t, e));
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return t(r);
}

function p(t, n) {
  var e = [t.x, t.y, t.z],
      r = n,
      a = [Math.cos(r), Math.sin(r)],
      o = Math.sqrt(a[0] * a[0] + a[1] * a[1]);
  if (0 === o) return null;
  a[0] /= o, a[1] /= o;

  var c = function c(t) {
    var n = (t.x - e[0]) * a[0] + (t.y - e[1]) * a[1];
    t.x = e[0] + n * a[0], t.y = e[1] + n * a[1];
  };

  return function (t) {
    return c(t.mapStart), c(t.mapEnd), t;
  };
}

function y(t, n) {
  var e = null;
  return function (r) {
    if ("start" === r.action && (e = x(t, r.mapStart.spatialReference, n)), a(e)) return null;
    var o = r.mapEnd.x - r.mapStart.x,
        c = r.mapEnd.y - r.mapStart.y,
        s = r.mapEnd.z - r.mapStart.z;
    return e.move(o, c, s), _objectSpread(_objectSpread({}, r), {}, {
      translationX: o,
      translationY: c,
      translationZ: s
    });
  };
}

function d(t, n) {
  return a(t) ? null : t.spatialReference.equals(n) ? t.clone() : l(t, n);
}

function x(t, n, e) {
  var r = t.geometry;
  if (a(r)) return null;
  if ("mesh" === r.type) return E(t, r, n, e);
  var o = d(r, n),
      c = r.spatialReference;
  return a(o) ? null : {
    move: function move(n, e, r) {
      var a = i(o.clone(), n, e, r);
      a.spatialReference.equals(c) ? t.geometry = a : t.geometry = l(a, c);
    }
  };
}

function E(t, n, e, a) {
  if (r(n.transform)) return h(t, n, n.transform, e);
  if (!n.spatialReference.equals(e)) return null;
  var o = 0,
      c = 0,
      s = 0;
  return {
    move: function move(e, r, l) {
      var i = e - o,
          u = r - c,
          m = l - s;

      if (i || u || m) {
        var _f = n.origin.clone().offset(i, u, m);

        n.centerAt(_f, {
          geographic: 1 === a
        }), t.notifyGeometryChanged(), o = e, c = r, s = l;
      }
    }
  };
}

function h(t, n, e, o) {
  var c = d(e.getOriginPoint(n.spatialReference), o),
      u = n.spatialReference;
  return a(c) ? null : {
    move: function move(n, a, o) {
      var m = i(c.clone(), n, a, o);
      if (m.spatialReference.equals(u)) e.origin = s(m.x, m.y, m.z);else {
        var _t2 = l(m, u);

        r(_t2) && (e.origin = s(_t2.x, _t2.y, _t2.z));
      }
      t.notifyGeometryChanged();
    }
  };
}

function g(t) {
  var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var e = arguments.length > 2 ? arguments[2] : undefined;
  var o = null;

  var c = r(n) && !t.spatialReference.equals(n) ? function (t) {
    return r(t) ? l(t, n) : t;
  } : function (t) {
    return t;
  },
      s = _objectSpread({
    exclude: []
  }, e);

  return function (n) {
    if ("start" === n.action && (o = c(t.toMap(n.screenStart, s))), a(o)) return null;
    var e = c(t.toMap(n.screenEnd, s));
    return r(e) ? _objectSpread(_objectSpread({}, n), {}, {
      mapStart: o,
      mapEnd: e
    }) : null;
  };
}

function S(t, n) {
  var e = t.map(function (t) {
    return o(y(t, n));
  }).filter(function (t) {
    return r(t);
  });
  return function (t) {
    var n = t.mapEnd.x - t.mapStart.x,
        r = t.mapEnd.y - t.mapStart.y,
        a = t.mapEnd.z - t.mapStart.z;
    return e.forEach(function (n) {
      return n(t);
    }), _objectSpread(_objectSpread({}, t), {}, {
      translationX: n,
      translationY: r,
      translationZ: a
    });
  };
}

function R(t, e) {
  var r = new Map();

  var _iterator2 = _createForOfIteratorHelper(e),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var _a = _step2.value;
      r.set(_a, n(t[_a]));
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return function (n) {
    return r.forEach(function (n, e) {
      t[e] = n;
    }), n;
  };
}

function z(t) {
  return r(t.geometry) && "mesh" === t.geometry.type ? j(t, t.geometry) : R(t, ["geometry"]);
}

function j(t, n) {
  var e = r(n.transform) ? n.transform.clone() : null,
      a = n.vertexAttributes.clonePositional();
  return function (r) {
    return n.transform = e, n.vertexAttributes = a, t.notifyGeometryChanged(), r;
  };
}

function v(t) {
  var n = t.map(function (t) {
    return o(z(t));
  }).filter(function (t) {
    return r(t);
  });
  return function (t) {
    return n.forEach(function (n) {
      return n(t);
    }), t;
  };
}

function w(t) {
  return R(t, ["symbol"]);
}

function q() {
  var t = 0,
      n = 0,
      e = 0;
  return function (r) {
    "start" === r.action && (t = r.mapStart.x, n = r.mapStart.y, e = r.mapStart.z);
    var a = r.mapEnd.x - t,
        o = r.mapEnd.y - n,
        c = r.mapEnd.z - e;
    return t = r.mapEnd.x, n = r.mapEnd.y, e = r.mapEnd.z, _objectSpread(_objectSpread({}, r), {}, {
      mapDeltaX: a,
      mapDeltaY: o,
      mapDeltaZ: c,
      mapDeltaSpatialReference: r.mapStart.spatialReference
    });
  };
}

function D() {
  var t = 0,
      n = 0;
  return function (e) {
    "start" === e.action && (t = e.screenStart.x, n = e.screenStart.y);
    var r = e.screenEnd.x - t,
        a = e.screenEnd.y - n;
    return t = e.screenEnd.x, n = e.screenEnd.y, _objectSpread(_objectSpread({}, e), {}, {
      screenDeltaX: r,
      screenDeltaY: a
    });
  };
}

function M(t, n) {
  var r = null,
      a = 0,
      o = 0;
  return function (s) {
    if ("start" === s.action && (r = t.toScreen(n), r.x < 0 || r.x > t.width || r.y < 0 || r.y > t.height ? r = null : (a = s.screenStart.x - r.x, o = s.screenStart.y - r.y)), null == r) return null;
    var l = e(s.screenEnd.x - a, 0, t.width),
        i = e(s.screenEnd.y - o, 0, t.height),
        u = c(l, i);
    return s.screenStart = r, s.screenEnd = u, s;
  };
}

var b = /*#__PURE__*/function () {
  function b() {
    _classCallCheck(this, b);

    this.execute = function () {};
  }

  _createClass(b, [{
    key: "next",
    value: function next(t) {
      var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new b();
      return r(t) && (this.execute = function (e) {
        var a = t(e);
        r(a) && n.execute(a);
      }), n;
    }
  }]);

  return b;
}();

export { b as EventPipeline, q as addMapDelta, D as addScreenDelta, p as constrainToMapAxis, u as createDragEventPipelineCallback, m as createManipulatorDragEventPipeline, f as createManipulatorDragEventPipelineMany, M as dragAtLocation, y as dragGraphic, S as dragGraphicMany, z as resetGraphic, v as resetGraphicMany, R as resetProperties, w as resetSymbol, g as screenToMap };